import {clsx} from 'external/clsx'
import { useEffect, Button } from 'external/react'

import getName from 'utilities/enum'

import useAuth from 'context/auth-context/hook'
import useFormValidation, {validators}  from 'utilities/form-validation'


import FormTextfield, { PasswordField } from 'components/FormTextfield'
import {notifyError} from 'components/Notify'

const { createEmailValidation, createRequiredFieldValidation} = validators

const loginValidations = {
	email: [createRequiredFieldValidation('email'), createEmailValidation('email')],
	password: [createRequiredFieldValidation('password')]
}

export default function LoginForm () {

	const {modals: {login: user}, login, showReset,showRegister, update} = useAuth()

	const [errors, validate] = useFormValidation(loginValidations)

	function createFieldProps (placeholder, fieldName, maxLength?) {
		return {
			placeholder,
			maxLength,
			fieldName,
			error: errors[fieldName],
			submitted: errors.submitted,
			onChange: (e) => {
				update({modals: {login: {[fieldName]: {$set: e.target.value.trim()}}}})
			}
		}
	}

	useEffect(() => { validate(user, false) }, [user])

	async function loginHandler () {
		if (!validate(user, true)) {
			return
		}

		try {
			const data = await login(user)
			const role = getName('role', data.role)
			switch (role) {
				case 'PARENT':
					if (window.location.pathname === '/summary'){
						window.location.reload();
					} else {
						window.location.replace('/home')
					}				
					break;
				case 'ADMIN_HOMESCHOOLER':
						window.location.replace('/admin')
					break
				case 'ACCOUNTING':
					window.location.replace('/accounting')
				break;
				default:
					break;
			}
			 
		} catch (err) {
			err && err['message'] && notifyError(err['message'])
		}
	}

	return (
		<form autoComplete='on'>
			<FormTextfield value={user.email} {...createFieldProps('Correo', 'email')} controlProps={{autoComplete: 'username'}} />
			<PasswordField value={user.password} {...createFieldProps('Contraseña', 'password')} controlProps={ {autoComplete: 'current-password', onKeyUp: e => { if (e.code === 'Enter') loginHandler() }}} />
			<div className={clsx('form-group', 'd-flex','justify-content-end')}>
				<a className='actions_reset_password' href='/' onClick={e => { e.preventDefault(); showReset() }}>Reiniciar contraseña</a>
			</div>
			<div className='actions_login mt-3'>
				<Button variant='primary' onClick={loginHandler}>Log In</Button>
				<Button className='mt-2' variant='light' onClick={() => showRegister()}>
					Registrar
				</Button>
			</div>
		</form>
	)
}